<template>
  <div class="app">
    <nav class="navbar navbar-dark bg-primary">
      <div class="container-fluid">
        <img v-if="images && images.carrier" :src="images.carrier" alt="carrier_logo" />
      </div>
    </nav>
    <router-view/>
  </div>
</template>
<script>

export default {
  inject: ['images']
}
</script>
